// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item {
  padding-top: 15px;
  padding-left: 20px;
}

.hide {
  display: none;
}

@media (max-width: 790px) {
  .item {
    border: solid;
    border-width: thin;
    padding: 9px !important;
  }
  .items {
    border: solid;
    border-width: thin;
    padding: 9px !important;
  }
}

.itemTitle {
  padding-left: 5px;
  background: rgb(217 217 217);
  margin-right: 9px;
  font-size: 12px;
}

@media (max-width: 790px) {
  .itemTitle {
    padding-left: 5px;
    background: rgb(217 217 217);
    font-size: 12px;
    width: 141px;
  }
}

.cicitemTitle {
  padding-left: 5px;
  background: rgb(217 217 217);
  font-size: 12px;
  width: 298px;
}

@media (max-width: 790px) {
  .cicitemTitle {
    padding-left: 5px;
    background: rgb(217 217 217);
    font-size: 12px;
    width: 298px;
  }
}

.selectStyle {
  width: 92%;
  margin-top: 9px;
}

.selectStyle:focus-visible {
  border: none !important;
}

.itemSelect {
  height: "53px";
}

.inputStyle {
  width: 1px;
}

.items {
  padding-top: 15px;
  padding-left: 20px;
  background-color: rgb(244, 216, 216);
}

.containerStyle {
  height: 100%;
}

.reset {
  text-align: center;
  margin: 4px;
  border-radius: 15px;
  border: thin solid;
  font-size: 12px;
  height: 43px;
  width: 99px;
  padding: 10px;
  margin-left: 21px;
  cursor: pointer;
}

.clear {
  text-align: center;
  border-radius: 15px;
  border: thin solid;
  font-size: 12px;
  height: 43px;
  width: 168px;
  margin-top: 4px;
  padding: 10px;
  cursor: pointer;
}

@media (max-width: 790px) {
  .cicwidth {
    width: 308px !important;
  }
}
.cicvalue {
  width: 72%;
  margin-left: -90px;
}
.cicdescription {
  width: 45%;
  padding-right: 0px;
  font-weight: bold;
}
.resetSection {
  margin-top: 3px;
  margin-left: 27px;
}
.clearSection {
  margin-top: 3px;
  margin-left: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Report/Filters/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,uBAAuB;EACzB;EAIA;IACE,aAAa;IACb,kBAAkB;IAClB,uBAAuB;EACzB;AAPF;;AAUA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,4BAA4B;IAC5B,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".item {\n  padding-top: 15px;\n  padding-left: 20px;\n}\n\n.hide {\n  display: none;\n}\n\n@media (max-width: 790px) {\n  .item {\n    border: solid;\n    border-width: thin;\n    padding: 9px !important;\n  }\n}\n\n@media (max-width: 790px) {\n  .items {\n    border: solid;\n    border-width: thin;\n    padding: 9px !important;\n  }\n}\n\n.itemTitle {\n  padding-left: 5px;\n  background: rgb(217 217 217);\n  margin-right: 9px;\n  font-size: 12px;\n}\n\n@media (max-width: 790px) {\n  .itemTitle {\n    padding-left: 5px;\n    background: rgb(217 217 217);\n    font-size: 12px;\n    width: 141px;\n  }\n}\n\n.cicitemTitle {\n  padding-left: 5px;\n  background: rgb(217 217 217);\n  font-size: 12px;\n  width: 298px;\n}\n\n@media (max-width: 790px) {\n  .cicitemTitle {\n    padding-left: 5px;\n    background: rgb(217 217 217);\n    font-size: 12px;\n    width: 298px;\n  }\n}\n\n.selectStyle {\n  width: 92%;\n  margin-top: 9px;\n}\n\n.selectStyle:focus-visible {\n  border: none !important;\n}\n\n.itemSelect {\n  height: \"53px\";\n}\n\n.inputStyle {\n  width: 1px;\n}\n\n.items {\n  padding-top: 15px;\n  padding-left: 20px;\n  background-color: rgb(244, 216, 216);\n}\n\n.containerStyle {\n  height: 100%;\n}\n\n.reset {\n  text-align: center;\n  margin: 4px;\n  border-radius: 15px;\n  border: thin solid;\n  font-size: 12px;\n  height: 43px;\n  width: 99px;\n  padding: 10px;\n  margin-left: 21px;\n  cursor: pointer;\n}\n\n.clear {\n  text-align: center;\n  border-radius: 15px;\n  border: thin solid;\n  font-size: 12px;\n  height: 43px;\n  width: 168px;\n  margin-top: 4px;\n  padding: 10px;\n  cursor: pointer;\n}\n\n@media (max-width: 790px) {\n  .cicwidth {\n    width: 308px !important;\n  }\n}\n.cicvalue {\n  width: 72%;\n  margin-left: -90px;\n}\n.cicdescription {\n  width: 45%;\n  padding-right: 0px;\n  font-weight: bold;\n}\n.resetSection {\n  margin-top: 3px;\n  margin-left: 27px;\n}\n.clearSection {\n  margin-top: 3px;\n  margin-left: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
